"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  addToBag: 'Add to bag',
  cataloguePrice: 'Catalogue price',
  deliveryFrequencyLabel: 'Delivery frequency',
  deliveryFrequencyOptions: 'Every 3rd week (Recommended);Every 4th week;Every 5th week;Every 6th week;Every 7th week;Every 8th week;Every 9th week',
  every2Week: 'Every 2nd week',
  every3Week: 'Every 3rd week',
  every4Week: 'Every 4th week',
  every5Week: 'Every 5th week',
  every6Week: 'Every 6th week',
  every7Week: 'Every 7th week',
  every8Week: 'Every 8th week',
  every9Week: 'Every 9th week',
  gotIt: 'Got it',
  learnMore: 'Learn more',
  mrp: 'MRP',
  mrpStatement: 'Inclusive of all taxes',
  priceCashback: '{price} cashback',
  purchaseOption: 'One-time purchase',
  quantity: 'Quantity',
  recommended: 'Recommended',
  regularPrice: 'Regular price',
  subscribeBenefits: 'Best nutrition results;30% cashback on every order;50 Hearts every campaign;Free shipping;Change, delay, or cancel anytime;Always lowest price',
  subscribeBenefitsBrandPartner: 'Best nutrition results;10% cashback on every order;Extra 20% Bonus Points;50 Hearts every campaign;Free shipping;Change, delay, or cancel anytime;Always lowest price',
  subscribeCashbackDescription: 'On every order',
  subscribeInfoDescriptions: 'A consistent routine leads to better results. Wellosophy’s subscription helps you stay on track with your nutrition and feel the difference over time.;Subscribe to any nutrition product and get 30% cashback on every single order – more wellness, more rewards.;Stay subscribed to your favourite nutrition products and get rewarded 50 Hearts every campaign – your fast track to exciting Beauty Rewards.;All subscription orders qualify for free shipping. Combine your next subscription shipment with your regular order to save even more.;You’ll get a reminder before each subscription order ships. You can choose to delay a delivery, change it, or cancel altogether – directly in your account.;If the product you’re subscribed to goes on offer, you automatically pay the lowest price – so you never miss a deal.',
  subscribeInfoDescriptionsBrandPartner: 'A consistent routine leads to better results. Wellosophy’s subscription helps you stay on track with your nutrition and feel the difference over time.;Enjoy 10% cashback on every subscription order – on top of your usual 20% Brand Partner discount.;As part of your subscription, you’ll receive an additional 20% Bonus Points for each product you order.;Stay subscribed to your favourite nutrition products and get rewarded 50 Hearts every campaign – your fast track to exciting Beauty Rewards.;All subscription orders qualify for free shipping. Combine your next subscription shipment with your regular order to save even more.;You’ll get a reminder before each subscription order ships. You can choose to delay a delivery, change it, or cancel altogether – directly in your account.;If the product you’re subscribed to goes on offer, you automatically pay the lowest price – so you never miss a deal.',
  subscribeInfoMainTitle: 'Subscription',
  subscribeInfoSubtitles: 'Best nutrition results;30% cashback on every order;50 Hearts every campaign;Free shipping;Change, delay, or cancel anytime;Always lowest price',
  subscribeInfoSubtitlesBrandPartner: 'Best nutrition results;10% cashback on every order;Extra 20% Bonus Points;50 Hearts every campaign;Free shipping;Change, delay, or cancel anytime;Always lowest price',
  subscribeOption: 'Subscribe & Save',
  yourPrice: 'Your price'
};
const translationsNamespace = exports.translationsNamespace = 'presentation-product-detail';
